/* unplugin-vue-components disabled */import script from "./pdfReader.vue?vue&type=script&lang=ts&setup=true"
export * from "./pdfReader.vue?vue&type=script&lang=ts&setup=true"

import "./pdfReader.vue?vue&type=style&index=0&id=1dec4900&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dec4900"]])

export default __exports__